import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const linkStyle = css`
	align-self: flex-start;
	padding: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	font-family: ${theme.fonts.body};
	font-size: 0.8125rem;
	font-weight: ${theme.fontWeights.medium};
	line-height: 1;
	color: ${theme.colors.accent};

	&:hover {
		color: ${theme.colors.accentDark};
	}
`;

type Props = {
	readonly label: string;
	readonly onClick: () => void;
};

/** The "← parent" link above a screen's title. */
const BackLink: React.FC<Props> = ({ label, onClick }) => {
	return (
		<button type="button" css={linkStyle} onClick={onClick}>
			← {label}
		</button>
	);
};

export default BackLink;
